module.exports = __webpack_public_path__ + "img/1a.8237fc22.png";